<app-sidebar class="p-col-fixed"></app-sidebar>
<div class="p-col" id="content-wrapper">
	<app-header></app-header>
	<div id="outlet-wrapper" class="p-shadow-1 p-p-3">
		<router-outlet></router-outlet>
	</div>
</div>